import { render, staticRenderFns } from "./CollectionTeaser.vue?vue&type=template&id=bb61ff6a&"
import script from "./CollectionTeaser.vue?vue&type=script&lang=js&"
export * from "./CollectionTeaser.vue?vue&type=script&lang=js&"
import style0 from "./CollectionTeaser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports